import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { PhotoProvider, PhotoView } from 'react-photo-view';

import DeviceLinkCell from 'components/TrapsTables/Cells/LinkCell/DevicesLinkCall';
import CustomPlaceholder from 'components/Utils/CustomPlaceHolder';
import { HubDetailPageApiResponse } from 'api/traps/Hubs/types';
import 'react-photo-view/dist/react-photo-view.css';
import './TrapDataTableCard.scss';

interface HubTableWithDataCardProps {
  data: HubDetailPageApiResponse | null;
  isLoading: boolean;
  isRefetching: boolean;
  slug: string;
}

const HubTableWithDataCard: React.FC<HubTableWithDataCardProps> = ({ data, isLoading, isRefetching }) => {
  const { t } = useTranslation();
  const AllDevice =
    (data?.mct.length || 0) + (data?.srbm.length || 0) + (data?.smst.length || 0) + (data?.srst.length || 0);
  return (
    <div className="card shadow-lg card-height-100 pt-3">
      <div className="card-body text-center">
        <div className="card-body">
          <div className="table-card mb-0">
            <table className="table mb-0 table-sm">
              <div className="d-flex flex-column justify-content-between" style={{ minHeight: '75px' }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex p-0 fw-medium">{t('MCTDetail.TrapDataTableCard.serialNumber')}</div>
                  <div className="d-flex p-0">
                    {isLoading || isRefetching ? (
                      <CustomPlaceholder colSize={10} />
                    ) : (
                      `${data?.hub.serial_number || 'N/A'}`
                    )}
                  </div>
                </div>
                <div
                  className="d-flex justify-content-between align-items-center mt-4 mb-1"
                  title={t('MCTDetail.TrapDataTableCard.toltipHub')}
                >
                  <div className="d-flex p-0 fw-medium">{t('MCTDetail.TrapDataTableCard.deviceAssigned')}</div>
                  <div className="d-flex p-0">
                    {isLoading || isRefetching ? (
                      <CustomPlaceholder colSize={12} />
                    ) : data?.hub.last_connect ? (
                      <div className="d-flex flex-column flex-2xl-row">{AllDevice}</div>
                    ) : (
                      '---'
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
                  <div className="d-flex p-0 fw-medium">{t('MCTDetail.TrapDataTableCard.lastConnection')}</div>
                  <div className="d-flex p-0">
                    {isLoading || isRefetching ? (
                      <CustomPlaceholder colSize={12} />
                    ) : data?.hub.last_connect ? (
                      <div className="d-flex flex-column flex-2xl-row">
                        <div>{dayjs(data?.hub.last_connect).format('DD-MM-YYYY')}&nbsp;</div>
                        <div>{dayjs(data?.hub.last_connect).format('HH:mm')}</div>
                      </div>
                    ) : (
                      '---'
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
                  <div className="d-flex p-0 fw-medium">{t('MCTDetail.TrapDataTableCard.map')}</div>
                  <div className="d-flex p-0">
                    {isLoading || isRefetching ? (
                      <CustomPlaceholder colSize={12} />
                    ) : (
                      <DeviceLinkCell
                        data={data?.hub.default_plan ?? null}
                        icon="ri-treasure-map-line"
                        slug={data?.hub.object_slug || ''}
                      />
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
                  <div className="d-flex p-0 fw-medium">{t('HubDetail.cards.installationPicture')}</div>
                  <div className="d-flex p-0">
                    {isLoading || isRefetching ? (
                      <CustomPlaceholder colSize={12} />
                    ) : data?.hub.installment_picture ? (
                      <PhotoProvider>
                        <PhotoView src={`${process.env.REACT_APP_BASE_DJANGO_URL}${data?.hub.installment_picture}`}>
                          <img
                            src={`${process.env.REACT_APP_BASE_DJANGO_URL}${data?.hub.installment_picture}`}
                            alt=""
                            title={t('HubDetail.cards.installationPicture')}
                            className="rounded avatar-xs"
                            style={{ cursor: 'pointer' }}
                          />
                        </PhotoView>
                      </PhotoProvider>
                    ) : (
                      t('HubDetail.cards.noPhoto')
                    )}
                  </div>
                </div>
              </div>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubTableWithDataCard;
